// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.Header--header--P7xyy {
  position: relative;
  display: table;
  padding-left: 0px;
  margin-bottom: 5px;
}
.Header--headerOuter--axeXC:nth-last-of-type(1) .Header--headerInner--LYL8h{
  transition-property: width;
  transition-duration: .25s;
  overflow: hidden;
}
.Header--headerClosed--YQpTc .Header--headerOuter--axeXC:nth-last-of-type(1) .Header--headerInner--LYL8h {
  width: 0px;
}
.Header--headerExpanded--y_ese .Header--headerOuter--axeXC:nth-last-of-type(1) .Header--headerInner--LYL8h {
  width: 100%;
}
.Header--headerOuter--axeXC {
  display: inline-block;
  font-weight: 300;
  overflow: hidden;
}
.Header--headerInner--LYL8h {
  display: block;
  margin: 5px 5px 5px 0;
  white-space: nowrap;
}
.Header--headerOuter--axeXC:nth-last-of-type(2) {
  padding-right: 10px;
}
.Header--headerClosed--YQpTc .Header--headerOuter--axeXC:nth-last-of-type(2)::after {
  content: '›';
  font-size: 15px;
  font-weight: bold;
  position: absolute;
  right: 5px;
  top: 45%;
  transform: translateY(-50%);
}
.Header--headerExpanded--y_ese .Header--headerOuter--axeXC:nth-last-of-type(2)::after {
  content: '›';
  font-size: 15px;
  font-weight: bold;
  position: absolute;
  right: 5px;
  top: 55%;
  transform: rotate(180deg) translateY(50%);
}

@media print {

  .Header--headerOuter--axeXC {
    color: var(--text-black);
  }

  .Header--headerOuter--axeXC:first-of-type {
    color: var(--text-black);
    font-weight: normal;
    font-size: 16px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/settings/common/Header.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;;EAEE;IAEE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;EACjB;;AAEF","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.header {\n  position: relative;\n  display: table;\n  padding-left: 0px;\n  margin-bottom: 5px;\n}\n.headerOuter:nth-last-of-type(1) .headerInner{\n  transition-property: width;\n  transition-duration: .25s;\n  overflow: hidden;\n}\n.headerClosed .headerOuter:nth-last-of-type(1) .headerInner {\n  width: 0px;\n}\n.headerExpanded .headerOuter:nth-last-of-type(1) .headerInner {\n  width: 100%;\n}\n.headerOuter {\n  composes: header;\n  display: inline-block;\n  font-weight: 300;\n  overflow: hidden;\n}\n.headerInner {\n  composes: header;\n  display: block;\n  margin: 5px 5px 5px 0;\n  white-space: nowrap;\n}\n.headerOuter:nth-last-of-type(2) {\n  padding-right: 10px;\n}\n.headerClosed .headerOuter:nth-last-of-type(2)::after {\n  content: '›';\n  font-size: 15px;\n  font-weight: bold;\n  position: absolute;\n  right: 5px;\n  top: 45%;\n  transform: translateY(-50%);\n}\n.headerExpanded .headerOuter:nth-last-of-type(2)::after {\n  content: '›';\n  font-size: 15px;\n  font-weight: bold;\n  position: absolute;\n  right: 5px;\n  top: 55%;\n  transform: rotate(180deg) translateY(50%);\n}\n\n@media print {\n\n  .headerOuter {\n    composes: lightText largeSize from '../../../styles/typography.css';\n    color: var(--text-black);\n  }\n\n  .headerOuter:first-of-type {\n    color: var(--text-black);\n    font-weight: normal;\n    font-size: 16px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header--header--P7xyy`,
	"headerOuter": `Header--headerOuter--axeXC Header--header--P7xyy ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["largeSize"]}`,
	"headerInner": `Header--headerInner--LYL8h Header--header--P7xyy`,
	"headerClosed": `Header--headerClosed--YQpTc`,
	"headerExpanded": `Header--headerExpanded--y_ese`
};
export default ___CSS_LOADER_EXPORT___;
